// extracted by mini-css-extract-plugin
export default {"title":"_timeout_title_MGBcZ"};